import React, { useState } from 'react';
import './TcnProductImage.css';

export default function TcnProductImage({ product }) {
    const [failedUrl, setFailedUrl] = useState(null);
    const url = product?.imageUrl;
    return url && failedUrl !== url
        ? <img className="tcn-product-image" src={url} alt={`Imagen de ${product.name}`} loading="lazy" onError={() => setFailedUrl(url)} />
        : <span className="tcn-product-image-placeholder">{product ? 'Sin imagen' : 'Pendiente de producto'}</span>;
}
